module.exports = __webpack_public_path__ + "static/media/treatment_var_low.122c87df.png";